/**
 * 지원 언어 상수 정의
 */

export const Language = Object.freeze({
  KO: 'ko',
  EN: 'en',
  JA: 'ja',
  AR: 'ar'
});

export const DEFAULT_LANGUAGE = Language.KO;

// 언어 코드 → 표시 이름
export const LANGUAGE_NAMES = Object.freeze({
  [Language.KO]: '한국어',
  [Language.EN]: 'English',
  [Language.JA]: '日本語',
  [Language.AR]: 'العربية'
});

// 언어 코드 → TTS/STT 언어 코드
export const SPEECH_LANG_CODES = Object.freeze({
  [Language.KO]: 'ko-KR',
  [Language.EN]: 'en-US',
  [Language.JA]: 'ja-JP',
  [Language.AR]: 'ar-SA'
});

// 유효한 언어 코드인지 확인
export function isValidLanguage(lang) {
  return Object.values(Language).includes(lang);
}

// 언어 코드 정규화 (잘못된 값이면 기본값 반환)
export function normalizeLanguage(lang) {
  if (!lang) return DEFAULT_LANGUAGE;
  const code = lang.toLowerCase().slice(0, 2);
  return isValidLanguage(code) ? code : DEFAULT_LANGUAGE;
}
